import { ForgotPasswordContainer } from "../../Componant/organisms/ForgotPassword";

type Props = {};

function ForgotPassword({}: Props) {
  return (
    <div className="page-body">
      <ForgotPasswordContainer />
    </div>
  );
}

export default ForgotPassword;
